var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute z-30",style:({ left: _vm.x + 'px', top: _vm.y + 'px', transform: 'rotate(' + _vm.rotate + 'deg)' })},[_c('img',{staticClass:"h-52 max-w-none",attrs:{"src":'/public/Calypso_Logo-' + _vm.no + '.svg',"alt":"Calypso Mahieu"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }